// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__Zkfx6","title":"ClientInsurance_title__2AF2A","itemText":"ClientInsurance_itemText__3iIzu"};